import { atom } from 'recoil';
import { atEveryOptions, defaultMinuteOptionsWithOrdinal, defaultWeekSelection, DEFAULT_DAY_OF_MONTH_OPTS, DEFAULT_DAY_OF_MONTH_OPTS_WITH_ORD, DEFAULT_HOUR_OPTS_EVERY, DEFAULT_MINUTE_OPTS, DEFAULT_MONTH_OPTS, onEveryOptions, periodOptions } from './constants';
import { getTimesOfTheDay } from './utils';
export const periodState = atom({
  key: 'periodState',
  default: periodOptions[1]
});
export const minuteState = atom({
  key: 'minuteState',
  default: [DEFAULT_MINUTE_OPTS[0]]
});
export const minuteAtEveryState = atom({
  key: 'minuteAtEveryState',
  default: atEveryOptions[0]
});
export const minuteRangeStartSchedulerState = atom({
  key: 'minuteRangeStartSchedulerState',
  default: defaultMinuteOptionsWithOrdinal()[0]
});
export const minuteRangeEndSchedulerState = atom({
  key: 'minuteRangeEndSchedulerState',
  default: defaultMinuteOptionsWithOrdinal()[59]
});
export const hourState = atom({
  key: 'hourState',
  default: [DEFAULT_HOUR_OPTS_EVERY[0]]
});
export const hourAtEveryState = atom({
  key: 'hourAtEveryState',
  default: atEveryOptions[0]
});
export const hourRangeStartSchedulerState = atom({
  key: 'hourRangeStartSchedulerState',
  default: getTimesOfTheDay()[0]
});
export const hourRangeEndSchedulerState = atom({
  key: 'hourRangeEndSchedulerState',
  default: getTimesOfTheDay()[23]
});
export const dayOfMonthAtEveryState = atom({
  key: 'dayOfMonthAtEveryState',
  default: onEveryOptions[0]
});
export const dayOfMonthState = atom({
  key: 'dayOfMonthState',
  default: DEFAULT_DAY_OF_MONTH_OPTS
});
export const dayOfMonthRangeStartSchedulerState = atom({
  key: 'dayOfMonthRangeStartSchedulerState',
  default: DEFAULT_DAY_OF_MONTH_OPTS_WITH_ORD[0]
});
export const dayOfMonthRangeEndSchedulerState = atom({
  key: 'dayOfMonthRangeEndSchedulerState',
  default: DEFAULT_DAY_OF_MONTH_OPTS_WITH_ORD[30]
});
export const weekState = atom({
  key: 'weekState',
  default: defaultWeekSelection()
});
export const monthState = atom({
  key: 'monthState',
  default: DEFAULT_MONTH_OPTS
});
export const cronValidationErrorMessageState = atom({
  key: 'cronValidationErrorMessageState',
  default: ''
});
export const isAdminState = atom({
  key: 'isAdminState',
  default: false
});
export const cronExpInputState = atom({
  key: 'cronExpInputState',
  default: '0 0 * * *'
});